import { formatPriceWithCommas } from '../utils/stringUtils';

import ListView from '../Common/Views/ListView';

import { itemTypeToLabel } from "./itemUtils";

const ItemsList = ({
    title = null,
    type = null, // 'PRODUCT' or 'SERVICE' - determines which items to show

    filters = {},
    addButton = true,
    addButtonLabel = null,
    addButtonPath = null,
    onSelect = null,

    columns = null, // array if specific columns from the columnsConfig to show in the list view. If null, all columns will be shown.

    searchBox = true,

    searchAttributes = [
        { name: 'name', label: 'Name', type: 'text' },
        { name: 'code', label: 'Code', type: 'text' },
    ],
    noResultsMessage = "No items found"
}) => {

    // Merge type into filters
    const mergedFilters = { ...filters };
    if (type) {
        mergedFilters.type = type;
    }

    // Determine URL prefix based on type
    const typePathSegment = type === 'SERVICE' ? 'services' : 'products';

    // Columns configuration for rendering items list
    const columnsConfig = {
        name: {
            key: 'name',
            label: 'Name',
            render: row => row.name
        },

        categoryName: {
            key: 'categoryName',
            label: 'Category',
            render: row => row.category ? row.category.name : ''
        },

        code: {
            key: 'code',
            label: 'Code',
            render: row => row.code
        },

        unitPrice: {
            key: 'unitPrice',
            label: 'Unit Price',
            render: row => `${formatPriceWithCommas(row.unitPrice)}/${row.uom}`
        },
    };

    return <ListView
        title={title || `${itemTypeToLabel(type)}s`}
        apiPath="/tenants/items"
        filters={mergedFilters}
        addButton={addButton}
        addButtonLabel={addButtonLabel || `Add new ${type ? itemTypeToLabel(type).toLowerCase() : 'item'}`}
        addPath={addButtonPath || (type ? `/items/${typePathSegment}/add` : '/items/products/add')}
        rowClickPath={(item) => `/items/${item.type === 'SERVICE' ? 'services' : 'products'}/${item.id}`}
        onSelect={onSelect}
        columnsConfig={columnsConfig}
        columns={columns}
        searchBox={searchBox}
        searchAttributes={searchAttributes}
        noResultsMessage={noResultsMessage}
    />
};

export default ItemsList;